// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2qCGL","icon":"SortAdornment_icon__2_Ul5","up":"SortAdornment_up__1f8Zp","down":"SortAdornment_down__3YyGa","active":"SortAdornment_active__3w0hS"};